module.exports = process.env.GATSBY_SITE_LANGUAGES ? process.env.GATSBY_SITE_LANGUAGES.split(',') : [''];